module.exports = __webpack_public_path__ + "static/img/card-award-bg.cef19cae.png";